import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { updatePassword, updateUser, updateUserEmail, getUser, deleteAccount, disableAccount } from "./requests";
import type { CustomQueryOptions, User } from "../types";

export const useGetUserQuery = (userId: string, options?: CustomQueryOptions<User>) => {
  return useQuery({
    queryKey: ['user', userId],
    queryFn: () => getUser(userId),
    ...options,
  });
};

export const useUpdatePasswordMutation = (userId: string, onSuccess?: (data: any) => void, onError?: (error: any) => void) => {
  return useMutation({
    mutationFn: (data: { currentPassword: string; newPassword: string }) => updatePassword(userId, data),
    onSuccess,
    onError,
  });
};

export const useUpdateUserMutation = (userId: string, onSuccess?: (data: any) => void, onError?: (error: any) => void) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data: { fullName: string; phone: string; linkedInUrl: string }) => updateUser(userId, data),
    onSuccess,
    onError,
    onSettled: () => {
      queryClient.invalidateQueries({ queryKey: ['user', userId] });
    }
  });
};

export const useUpdateUserEmailMutation = (userId: string, onSuccess?: (data: any) => void, onError?: (error: any) => void) => {
  return useMutation({
    mutationFn: (data: { newEmail: string }) => updateUserEmail(userId, data),
    onSuccess,
    onError,
  });
};

export const useDeleteAccountMutation = (userId: string, onSuccess?: (data: any) => void, onError?: (error: any) => void) => {
  return useMutation({
    mutationFn: (password: string) => deleteAccount(userId, password),
    onSuccess,
    onError,
  });
};

export const useDisableAccountMutation = (userId: string, onSuccess?: (data: any) => void, onError?: (error: any) => void) => {
  return useMutation({
    mutationFn: (password: string) => disableAccount(userId, password),
    onSuccess,
    onError,
  });
};

